module.exports = __webpack_public_path__ + "static/media/properties_img.b703889f.png";